import styled from 'styled-components';

const EditorsWrapper = styled.div`
  & div {
    margin: 0;
  }
  .Collapsible {
    margin-bottom: 20px;
  }
`;

export { EditorsWrapper };
